<template>
    <div>
        <div class="content-box">
            <div class="row element-wrapper">
                <div class="col-lg-12">
                    <div class="element-box">
                        <h5 class="form-header">Impresión de Etiquetas Personalizadas</h5>
                        <div class="form-desc">
                            Seleccione el tipo de etiqueta que desea configurar e imprimir
                        </div>

                        <nav>
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <a class="nav-item nav-link" :class="{ active: activeTab === 'etiquetas_custom' }"
                                    @click.prevent="activeTab = 'etiquetas_custom'" href="#" role="tab">
                                    Etiquetas Personalizadas
                                </a>
                                <a class="nav-item nav-link" :class="{ active: activeTab === 'lista_habladores' }"
                                    @click.prevent="activeTab = 'lista_habladores'" href="#" role="tab">
                                    Lista de Habladores
                                </a>
                            </div>
                        </nav>

                        <div class="tab-content pt-4" id="nav-tabContent">
                            <!-- Pestaña 1: Etiquetas Personalizadas (Texto Libre) -->
                            <div v-if="activeTab === 'etiquetas_custom'" class="tab-pane fade show active" role="tabpanel">
                                <div>
                                    <label style="font-size: 15px; font-weight: 500;">Previsualización de Impresión</label>
                                    <label style="text-align: right; float: right; font-size: 14px;">
                                        Impresión Duplicada &nbsp;
                                        <label class="switch" @change="syncEtiquetas">
                                            <input type="checkbox" v-model="imprimirLoMismo" />
                                            <span class="slider-button"></span>
                                        </label>
                                    </label>
                                </div>
                                <br><br>
                                <div style="background: #c2c3c4; 
                                           width: 100%; 
                                           max-width: 1085px; 
                                           height: 400px; 
                                           margin: 0 auto; 
                                           padding: 20px; 
                                           display: flex; 
                                           justify-content: center;
                                           align-items: center; 
                                           border-radius: 10px; 
                                           box-shadow: 0 0 20px rgba(194, 195, 196, 0.5);">
                                    <div
                                        style="display: flex; justify-content: center; align-items: center; flex-wrap: wrap; width: 100%;">
                                        <div id="etiqueta1" style="flex: 1 1 45%; 
                                                   min-width: 300px; 
                                                   height: 150px; 
                                                   background-color: white; 
                                                   margin: 10px; 
                                                   text-align: center; 
                                                   border-radius: 10px;">
                                            <input type="text" v-model="etiqueta1Texto"
                                                :placeholder="getInspirationalPlaceholder"
                                                style="width: 90%; height: 100%; border: none; outline: none; text-align: center; font-size: 14px;">
                                        </div>
                                        <div id="etiqueta2" style="flex: 1 1 45%; 
                                                   min-width: 300px; 
                                                   height: 150px; 
                                                   background-color: white; 
                                                   margin: 10px; 
                                                   text-align: center; 
                                                   border-radius: 10px;">
                                            <input type="text" v-model="etiqueta2Texto" :disabled="imprimirLoMismo"
                                                :placeholder="imprimirLoMismo ?
                                                    'Copiaré lo mismo que en la primera etiqueta.'
                                                    :
                                                    'Escribe algo por aquí también...'" style="width: 90%; 
                                                       height: 100%; 
                                                       border: none; 
                                                       outline: none; 
                                                       text-align: center; 
                                                       font-size: 14px; 
                                                       background-color: white;">
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div style="float: right;">
                                    <button class="btn btn-md glow-on-hover" v-if="etiqueta1Texto || etiqueta2Texto"
                                        @click="deshacerCambios">
                                        <i class="fas fa-undo" style="font-size: 13px;"></i>
                                    </button>
                                    <button class="btn btn-md glow-on-hover" @click="imprimirEtq()">Imprimir &nbsp;<i
                                            class="fas fa-print"></i></button>
                                </div>
                                <br><br>
                            </div>

                            <!-- Pestaña 2: Lista de Habladores -->
                            <div v-if="activeTab === 'lista_habladores'" class="tab-pane fade show active" role="tabpanel">
                                <div class="row align-items-start mb-2">
                                    <div class="col-md-5 col-sm-12 mb-3 mb-md-0">
                                        <div class="form-group">
                                            <TiendaSelectComponent :myprofile="true" :current="current"
                                                titulo="Tienda (Asignadas al Usuario)" />
                                        </div>
                                    </div>
                                    <div v-if="vista === 'detalle' && esAbierta" class="col-md-7 col-sm-12">
                                        <div class="form-group">
                                            <label class="font-weight-bold">Escaneo / Búsqueda de Producto</label>
                                            <div class="d-flex flex-wrap align-items-center" style="gap: 8px;">
                                                <div class="input-group flex-grow-1" style="min-width: 220px;">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text bg-white text-primary">
                                                            <i class="fas fa-barcode"></i>
                                                        </span>
                                                    </div>
                                                    <input ref="inputBusqueda" type="text" class="form-control"
                                                        v-model="busquedaProducto"
                                                        @keyup.enter="buscarYAgregarProducto"
                                                        placeholder="Escanee código o SKU..."
                                                        :disabled="!puedeAgregar" />
                                                    <div v-if="busquedaProducto" class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button"
                                                            @click="limpiarInputBusqueda" title="Borrar texto">
                                                            <i class="fas fa-times"></i>
                                                        </button>
                                                    </div>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-primary px-3 font-weight-bold" type="button"
                                                            @click="buscarYAgregarProducto"
                                                            :disabled="!puedeAgregar || !busquedaProducto.trim()">
                                                            <i v-if="cargandoBusqueda" class="fas fa-spinner fa-spin"></i>
                                                            <i v-else class="fas fa-plus"></i> &nbsp;Agregar
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col-camara-wrapper">
                                                    <button class="btn btn-info px-3 font-weight-bold btn-camara-action" type="button"
                                                        @click="abrirScannerCamara"
                                                        :disabled="!puedeAgregar"
                                                        title="Escanear código con la cámara del Smartphone">
                                                        <i class="fas fa-camera"></i> &nbsp;Cámara
                                                    </button>
                                                </div>
                                            </div>
                                            <small v-if="listaLlena" class="form-text text-danger mt-1">
                                                <i class="fas fa-exclamation-circle"></i> La lista llegó al máximo de {{ maxProductos }} productos. Ciérrela y cree una lista nueva.
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <!-- Vista 1: Listas de la tienda -->
                                <div v-if="vista === 'listas'">
                                    <hr>
                                    <div class="row align-items-center mb-3">
                                        <div class="col-md-5 col-sm-12 mb-2 mb-md-0">
                                            <h6 class="mb-0 font-weight-bold text-dark d-flex align-items-center">
                                                <i class="fas fa-layer-group text-primary mr-2" style="font-size: 1.1rem;"></i>
                                                <span>Listas de la Tienda</span>
                                                <span class="badge badge-pill badge-primary ml-2 px-2 py-1" style="font-size: 12px;">{{ listas.length }}</span>
                                            </h6>
                                        </div>
                                        <div class="col-md-7 col-sm-12 text-right">
                                            <div class="header-actions-group d-inline-flex flex-wrap justify-content-end align-items-center w-100">
                                                <button class="btn btn-outline-primary btn-action"
                                                    @click="cargarListas"
                                                    :disabled="!current.tienda || cargandoListas">
                                                    <i class="fas fa-sync-alt" :class="{ 'fa-spin': cargandoListas }"></i> Actualizar
                                                </button>
                                                <button class="btn btn-success btn-action"
                                                    @click="crearLista"
                                                    :disabled="!current.tienda || creandoLista">
                                                    <i class="fas fa-plus"></i> Nueva Lista
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive" style="max-height: 450px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 6px;">
                                        <table class="table table-bordered table-striped table-hover align-middle mb-0">
                                            <thead class="thead-light" style="position: sticky; top: 0; z-index: 10; background-color: #e9ecef;">
                                                <tr>
                                                    <th style="width: 60px;" class="text-center">#</th>
                                                    <th>Creada por</th>
                                                    <th style="width: 150px;" class="text-center">Fecha</th>
                                                    <th style="width: 110px;" class="text-center">Productos</th>
                                                    <th style="width: 150px;" class="text-center">Estado</th>
                                                    <th style="width: 170px;" class="text-center">Impresión</th>
                                                    <th style="width: 240px;" class="text-center">Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(lista, index) in listas" :key="lista.id">
                                                    <td class="text-center font-weight-bold text-muted align-middle">{{ index + 1 }}</td>
                                                    <td class="align-middle">{{ lista.usuario_crea_nombre }}</td>
                                                    <td class="text-center align-middle">{{ formatearFecha(lista.fecha_creacion) }}</td>
                                                    <td class="text-center align-middle font-weight-bold">{{ lista.total_productos }} / {{ lista.max_productos }}</td>
                                                    <td class="text-center align-middle">
                                                        <span v-if="lista.estatus === 'A'" class="badge badge-warning px-2 py-1">
                                                            <i class="fas fa-lock-open mr-1"></i> Abierta
                                                        </span>
                                                        <span v-else class="badge badge-dark px-2 py-1">
                                                            <i class="fas fa-lock mr-1"></i> Cerrada
                                                        </span>
                                                        <div v-if="lista.estatus === 'C'" class="small text-muted mt-1">
                                                            {{ lista.usuario_cierra_nombre }}
                                                        </div>
                                                    </td>
                                                    <td class="text-center align-middle">
                                                        <span v-if="lista.veces_impreso > 0" class="badge badge-info px-2 py-1">
                                                            <i class="fas fa-print mr-1"></i> Impresa{{ lista.veces_impreso > 1 ? ' (' + lista.veces_impreso + ')' : '' }}
                                                        </span>
                                                        <span v-else class="badge badge-secondary px-2 py-1">
                                                            <i class="fas fa-clock mr-1"></i> No impresa
                                                        </span>
                                                        <div v-if="lista.veces_impreso > 0 && lista.pendientes_imprimir > 0" class="small text-danger mt-1">
                                                            {{ lista.pendientes_imprimir }} sin imprimir
                                                        </div>
                                                        <div v-else-if="lista.veces_impreso > 0" class="small text-muted mt-1">
                                                            {{ lista.usuario_imprime_nombre }}<br>{{ formatearFecha(lista.fecha_impresion) }}
                                                        </div>
                                                    </td>
                                                    <td class="text-center align-middle cell-acciones">
                                                        <div class="d-flex justify-content-center align-items-center flex-wrap" style="gap: 8px;">
                                                            <button class="btn btn-info btn-touch-action" @click="abrirLista(lista)" title="Ver productos e imprimir">
                                                                <i class="fas fa-eye"></i> Ver
                                                            </button>
                                                            <button class="btn btn-primary btn-touch-action" @click="continuarLista(lista)"
                                                                :title="lista.estatus === 'A' ? 'Seguir agregando productos' : 'Reabrir para agregar productos'">
                                                                <i class="fas fa-plus"></i> {{ lista.estatus === 'A' ? 'Agregar' : 'Reabrir' }}
                                                            </button>
                                                            <button class="btn btn-danger btn-touch-action" @click="anularLista(lista)" title="Anular lista">
                                                                <i class="fas fa-trash-alt"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-if="listas.length === 0">
                                                    <td colspan="7" class="text-center py-4 text-muted">
                                                        <i class="fas fa-layer-group mb-2" style="font-size: 32px; display: block;"></i>
                                                        <span v-if="current.tienda">No hay listas en esta tienda. Use "Nueva Lista" para comenzar.</span>
                                                        <span v-else>Seleccione una tienda para ver sus listas.</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <small class="form-text text-muted">Las listas se eliminan automáticamente a los 2 días de creadas.</small>
                                </div>

                                <!-- Vista 2: Detalle de una lista -->
                                <div v-if="vista === 'detalle' && listaActual">
                                <div v-if="!esAbierta" class="alert alert-secondary py-2 mb-2">
                                    <i class="fas fa-lock mr-1"></i> Lista cerrada<span v-if="listaActual.usuario_cierra_nombre"> por {{ listaActual.usuario_cierra_nombre }} ({{ formatearFecha(listaActual.fecha_cierre) }})</span>. Para agregar productos use "Reabrir".
                                </div>
                                <hr>

                                <!-- Acciones y Resumen -->
                                <div class="row align-items-center mb-3">
                                    <div class="col-md-4 col-sm-12 mb-2 mb-md-0">
                                        <h6 class="mb-0 font-weight-bold text-dark d-flex align-items-center flex-wrap">
                                            <span v-if="esAbierta" class="badge badge-warning mr-2 px-2 py-1"><i class="fas fa-lock-open mr-1"></i> Abierta</span>
                                            <span v-else class="badge badge-dark mr-2 px-2 py-1"><i class="fas fa-lock mr-1"></i> Cerrada</span>
                                            <span>Productos</span>
                                            <span class="badge badge-pill badge-primary ml-2 px-2 py-1" style="font-size: 12px;">{{ listaHabladores.length }} / {{ maxProductos }}</span>
                                        </h6>
                                        <div class="small text-muted mt-1">
                                            <i class="fas fa-user"></i> {{ listaActual.usuario_crea_nombre }} &nbsp;|&nbsp; {{ formatearFecha(listaActual.fecha_creacion) }}
                                        </div>
                                    </div>
                                    <div class="col-md-8 col-sm-12 text-right">
                                        <div class="header-actions-group d-inline-flex flex-wrap justify-content-end align-items-center w-100">
                                            <input v-if="listaHabladores.length > 5"
                                                type="text" class="form-control form-control-sm mr-md-2"
                                                v-model="filtroLista" placeholder="Filtrar en lista..." style="max-width: 180px;" />

                                            <button class="btn btn-outline-secondary btn-action" @click="volverAListas">
                                                <i class="fas fa-arrow-left"></i> Listas
                                            </button>

                                            <button class="btn btn-outline-primary btn-action"
                                                @click="cargarDetalle"
                                                :disabled="cargandoLista"
                                                title="Ver lo agregado desde otros equipos">
                                                <i class="fas fa-sync-alt" :class="{ 'fa-spin': cargandoLista }"></i> Actualizar
                                            </button>

                                            <button v-if="esAbierta" class="btn btn-success btn-action"
                                                @click="cerrarLista"
                                                :disabled="listaHabladores.length === 0"
                                                title="Terminé de agregar: dejar la lista para imprimir">
                                                <i class="fas fa-lock"></i> Cerrar Lista
                                            </button>

                                            <template v-else>
                                                <button class="btn btn-outline-primary btn-action"
                                                    @click="reabrirListaActual"
                                                    title="Reabrir para agregar productos">
                                                    <i class="fas fa-lock-open"></i> Reabrir
                                                </button>

                                                <button class="btn btn-primary btn-action"
                                                    @click="imprimirPendientes"
                                                    :disabled="pendientesImprimir.length === 0"
                                                    title="Imprimir solo lo que no se ha enviado a imprimir">
                                                    <i class="fas fa-print"></i> Imprimir Pendientes ({{ pendientesImprimir.length }})
                                                </button>

                                                <button class="btn btn-success btn-action"
                                                    @click="imprimirListaCompleta"
                                                    :disabled="listaHabladores.length === 0">
                                                    <i class="fas fa-print"></i> Imprimir Lista Completa
                                                </button>
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <!-- Tabla de Habladores con Scroll para Alto Volumen (200+ ítems) -->
                                <div ref="tablaContainer" class="table-responsive" style="max-height: 450px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 6px;">
                                    <table class="table table-bordered table-striped table-hover align-middle mb-0">
                                        <thead class="thead-light" style="position: sticky; top: 0; z-index: 10; background-color: #e9ecef;">
                                            <tr>
                                                <th style="width: 60px;" class="text-center">#</th>
                                                <th style="width: 160px;">SKU / Código</th>
                                                <th>Nombre del Producto</th>
                                                <th style="width: 140px;" class="text-center">Estatus (Tienda)</th>
                                                <th style="width: 170px;" class="text-center">Impresión</th>
                                                <th style="width: 190px;" class="text-center">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in listaFiltrada" :key="item.id">
                                                <td class="text-center font-weight-bold text-muted align-middle">{{ index + 1 }}</td>
                                                <td class="align-middle">
                                                    <span class="font-weight-bold text-dark">{{ item.sku }}</span>
                                                    <div v-if="item.barra_ingresada && item.barra_ingresada !== item.sku" class="small text-muted">
                                                        <i class="fas fa-barcode"></i> {{ item.barra_ingresada }}
                                                    </div>
                                                </td>
                                                <td class="align-middle">
                                                    {{ item.nombre }}
                                                    <div class="small text-muted">
                                                        <i class="fas fa-user"></i> {{ item.usuario_crea_nombre }} &nbsp;|&nbsp; {{ formatearFecha(item.fecha_creacion) }}
                                                    </div>
                                                </td>
                                                <td class="text-center align-middle">
                                                    <span v-if="item.activo_tienda" class="badge badge-success px-2 py-1">
                                                        <i class="fas fa-check-circle mr-1"></i> Activo
                                                    </span>
                                                    <span v-else class="badge badge-danger px-2 py-1">
                                                        <i class="fas fa-times-circle mr-1"></i> Inactivo
                                                    </span>
                                                </td>
                                                <td class="text-center align-middle">
                                                    <span v-if="item.fecha_impresion" class="badge badge-info px-2 py-1">
                                                        <i class="fas fa-print mr-1"></i> Impreso
                                                    </span>
                                                    <span v-else class="badge badge-secondary px-2 py-1">
                                                        <i class="fas fa-clock mr-1"></i> Pendiente
                                                    </span>
                                                    <div v-if="item.fecha_impresion" class="small text-muted mt-1">
                                                        {{ formatearFecha(item.fecha_impresion) }}
                                                    </div>
                                                </td>
                                                <td class="text-center align-middle cell-acciones">
                                                    <div class="d-flex justify-content-center align-items-center flex-wrap" style="gap: 8px;">
                                                        <button v-if="esCerrada" class="btn btn-info btn-touch-action"
                                                            @click="imprimirHabladorIndividual(item)"
                                                            title="Imprimir Hablador Individual">
                                                            <i class="fas fa-print"></i> Imprimir
                                                        </button>
                                                        <button v-if="esAbierta" class="btn btn-danger btn-touch-action"
                                                            @click="eliminarHablador(item)"
                                                            title="Eliminar de la lista">
                                                            <i class="fas fa-trash-alt"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="listaHabladores.length === 0">
                                                <td colspan="6" class="text-center py-4 text-muted">
                                                    <i class="fas fa-barcode mb-2" style="font-size: 32px; display: block;"></i>
                                                    La lista no tiene productos.<br>
                                                    <span v-if="esAbierta" class="small">Escanee o digite un código o SKU para comenzar.</span>
                                                </td>
                                            </tr>
                                            <tr v-else-if="listaFiltrada.length === 0">
                                                <td colspan="6" class="text-center py-3 text-muted">
                                                    No se encontraron coincidencias para "{{ filtroLista }}".
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Previsualización de Habladores (Oculto) -->
        <div v-if="false && modalPrevisualizacion" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.75); z-index: 1050;">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" style="max-width: 850px;">
                <div class="modal-content border-0 shadow-lg">
                    <div class="modal-header bg-dark text-white py-2 px-3 d-flex justify-content-between align-items-center">
                        <h5 class="modal-title mb-0" style="font-size: 1.1rem;">
                            <i class="fas fa-eye mr-2 text-info"></i> Previsualización de Habladores a Imprimir ({{ listaHabladores.length }} ítems)
                        </h5>
                        <button type="button" class="close text-white" @click="modalPrevisualizacion = false">
                            <span>&times;</span>
                        </button>
                    </div>
                    
                    <!-- Barra de Herramientas del Modal -->
                    <div class="bg-secondary text-white py-2 px-3 d-flex justify-content-between align-items-center small">
                        <span>
                            <i class="fas fa-store mr-1"></i> Tienda: <strong>{{ current.tienda }}</strong> &nbsp;|&nbsp;
                            <i class="fas fa-file-alt mr-1"></i> Formato: <strong>HabladoresEscaneadosPorTienda.jrxml</strong>
                        </span>
                        <div>
                            <button class="btn btn-sm btn-light font-weight-bold py-1 px-2" @click="imprimirListaCompleta">
                                <i class="fas fa-external-link-alt text-primary"></i> Abrir PDF Real ({{ listaHabladores.length }})
                            </button>
                        </div>
                    </div>

                    <div class="modal-body bg-secondary p-3" style="max-height: 75vh; overflow-y: auto;">
                        <!-- Hoja de Papel Simulación de Impresión -->
                        <div class="paper-sheet bg-white p-4 mx-auto shadow" style="max-width: 780px; min-height: 750px; border-radius: 4px; color: #000; font-family: Arial, Helvetica, sans-serif;">
                            
                            <div class="text-center border-bottom pb-2 mb-3">
                                <h6 class="font-weight-bold text-uppercase mb-0" style="letter-spacing: 1px; color: #333;">VISTA PREVIA DE HABLADORES (FORMATO REAL)</h6>
                                <small class="text-muted">Tienda: {{ current.tienda }} &nbsp;|&nbsp; Total habladores: {{ listaHabladores.length }}</small>
                            </div>

                            <!-- Lista de Habladores horizontales 100% idénticos a HabladoresEscaneadosPorTienda.jrxml -->
                            <div v-for="(item, idx) in listaHabladores" :key="'sheet-' + item.sku" class="hablador-row-item border border-dark mb-4 p-3 bg-white" style="border-width: 2px !important;">
                                <div class="row no-gutters">
                                    <!-- Columna Izquierda: Nombre, Código de Barras e Impreso -->
                                    <div class="col-7 pr-3 d-flex flex-column justify-content-between">
                                        <!-- Nombre del Producto -->
                                        <div class="font-weight-bold text-uppercase text-dark" style="font-size: 15px; line-height: 1.2; min-height: 38px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;" :title="item.nombre">
                                            {{ item.nombre }}
                                        </div>

                                        <!-- Código de Barras -->
                                        <div class="my-2 text-center" style="max-width: 260px;">
                                            <div class="barcode-bars-container d-flex justify-content-center align-items-center" style="height: 42px; overflow: hidden; background: #fff; padding: 2px 0;">
                                                <span v-for="n in 36" :key="n" :style="{ width: (n % 4 === 0 ? '3.5px' : (n % 3 === 0 ? '2px' : '1px')), height: '38px', backgroundColor: '#000', margin: '0 1px', display: 'inline-block' }"></span>
                                            </div>
                                            <div class="font-weight-bold text-dark font-monospace mt-1" style="font-size: 14px; letter-spacing: 1.5px;">
                                                {{ item.codigo_barras || item.sku }}
                                            </div>
                                        </div>

                                        <!-- Printed timestamp (Left footer) -->
                                        <div class="small text-muted" style="font-size: 10.5px;">
                                            Impreso: {{ fechaHoy }}
                                        </div>
                                    </div>

                                    <!-- Columna Derecha: Precio Grande, Oferta, Validez y Unidades (Uxc / Sos) -->
                                    <div class="col-5 pl-2 text-right d-flex flex-column justify-content-between">
                                        <!-- Precio Grande -->
                                        <div class="text-right">
                                            <div class="h1 font-weight-bold text-dark mb-0" style="font-size: 36px; letter-spacing: -1px; line-height: 1;">
                                                Q --.--
                                            </div>
                                            <div class="font-weight-bold text-dark mt-1" style="font-size: 13px;">
                                                1 Por Q --.-- c/u
                                            </div>
                                            <div class="text-muted" style="font-size: 11px;">
                                                Válido desde {{ fechaInicioValidez }}
                                            </div>
                                        </div>

                                        <!-- Pie Derecho: Unidades por Caja y Unidad de Medida (1.Uxc  4.Sos) -->
                                        <div class="font-weight-bold text-dark text-right" style="font-size: 13px; letter-spacing: 1px;">
                                            {{ item.uxc || 1 }}.Uxc &nbsp;&nbsp; {{ item.sos || 'Sos' }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    
                    <div class="modal-footer bg-white py-2 px-3">
                        <button type="button" class="btn btn-secondary" @click="modalPrevisualizacion = false">Cerrar</button>
                        <button type="button" class="btn btn-success font-weight-bold" @click="imprimirListaCompleta">
                            <i class="fas fa-print mr-1"></i> Imprimir Reporte PDF ({{ listaHabladores.length }})
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Escáner por Cámara Smartphone -->
        <div v-if="modalCamara" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.85); z-index: 1060;">
            <div class="modal-dialog modal-dialog-centered" style="max-width: 520px;">
                <div class="modal-content border-0 shadow-lg text-white" style="background-color: #1a1a24; border-radius: 12px; overflow: hidden;">
                    
                    <div class="modal-header border-bottom-0 py-3 px-4 d-flex justify-content-between align-items-center bg-dark">
                        <h6 class="modal-title font-weight-bold mb-0 text-white d-flex align-items-center">
                            <i class="fas fa-camera text-info mr-2" style="font-size: 1.2rem;"></i>
                            Escáner de Cámara (Smartphone)
                        </h6>
                        <button type="button" class="close text-white opacity-100" @click="cerrarScannerCamara">
                            <span>&times;</span>
                        </button>
                    </div>

                    <div class="modal-body p-3 text-center position-relative">
                        <!-- Mensaje de Error / Diagnóstico de Cámara -->
                        <div v-if="errorCamara" class="alert alert-danger text-left m-2 p-3 small" role="alert">
                            <h6 class="font-weight-bold mb-1"><i class="fas fa-exclamation-triangle mr-1"></i> {{ tituloErrorCamara }}</h6>
                            <p class="mb-0">{{ mensajeErrorCamara }}</p>
                        </div>

                        <!-- Visor del Escáner en Vivo -->
                        <div v-else class="scanner-viewport-wrapper position-relative mx-auto rounded overflow-hidden" style="max-width: 460px; min-height: 290px; background-color: #000;">
                            <EscanerCamaraBarras
                                v-if="camaraActiva"
                                @decode="onCamaraDecode"
                                @loaded="onCamaraLoaded"
                                @error="onCamaraError"
                            ></EscanerCamaraBarras>

                            <!-- Guía Visual de Enfoque Láser -->
                            <div class="scanner-overlay position-absolute t-0 l-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center" style="top: 0; left: 0; right: 0; bottom: 0; pointer-events: none;">
                                <div class="scanner-target-box border-info position-relative" :class="{ 'scanned-flash': codigoRecienteScan }">
                                    <div class="laser-line"></div>
                                </div>
                                <span class="badge badge-dark px-3 py-2 mt-3 shadow-sm small" style="opacity: 0.9; letter-spacing: 0.5px;">
                                    <i class="fas fa-expand mr-1 text-info"></i> Encuadre el código dentro del recuadro
                                </span>
                                <span class="badge badge-warning text-dark px-3 py-1 mt-2 shadow-sm small font-weight-bold">
                                    <i class="fas fa-search-plus mr-1"></i> Acerque el código hasta que se vea nítido
                                </span>
                            </div>
                        </div>

                        <!-- Confirmación y Último Código Leído -->
                        <div class="mt-3 p-2 bg-dark rounded border border-secondary small">
                            <span class="text-muted d-block small">Último código detectado:</span>
                            <strong :class="ultimoCodigoScan ? 'text-success' : 'text-warning'" style="font-size: 15px;">
                                {{ ultimoCodigoScan || 'Esperando lectura de barras...' }}
                            </strong>
                        </div>

                        <!-- Controles de Modo -->
                        <div class="d-flex justify-content-between align-items-center mt-3 px-2 small text-muted">
                            <label class="custom-control custom-switch mb-0 cursor-pointer">
                                <input type="checkbox" class="custom-control-input" id="escaneoContinuoSwitch" v-model="escaneoContinuo">
                                <label class="custom-control-label text-white" for="escaneoContinuoSwitch">Modo Continuo (Múltiples lecturas)</label>
                            </label>
                        </div>
                    </div>

                    <div class="modal-footer border-top-0 bg-dark py-2 px-3 d-flex justify-content-between align-items-center">
                        <button type="button" class="btn btn-secondary px-4" @click="cerrarScannerCamara">
                            <i class="fas fa-times mr-1"></i> Cerrar
                        </button>
                        <span class="small text-muted">Tienda: <strong>{{ current.tienda }}</strong><span v-if="motorCamara"> &nbsp;|&nbsp; Lector: {{ motorCamara }}</span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EscanerCamaraBarras from "./EscanerCamaraBarras";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import Notifications from "@/notifications/notifications";
import HabladorListaService from "@/services/catalogos/HabladorListaService";

export default {
    components: {
        TiendaSelectComponent,
        EscanerCamaraBarras,
    },
    data() {
        return {
            activeTab: 'etiquetas_custom',
            // Estado Pestaña 1
            etiqueta1Texto: '',
            etiqueta2Texto: '',
            imprimirLoMismo: true,
            // Estado Pestaña 2
            current: {
                tienda: '',
            },
            busquedaProducto: '',
            cargandoBusqueda: false,
            scanQueue: [],
            filtroLista: '',
            modalPrevisualizacion: false,
            tipoVistaModal: 'pdf',
            // 'listas': listas de la tienda; 'detalle': productos de listaActual
            vista: 'listas',
            listas: [],
            cargandoListas: false,
            creandoLista: false,
            listaActual: null,
            listaHabladores: [],
            cargandoLista: false,
            motorCamara: '',

            // Estado Escáner Cámara Smartphone
            modalCamara: false,
            camaraActiva: false,
            escaneoContinuo: true,
            ultimoCodigoScan: '',
            codigoRecienteScan: false,
            errorCamara: false,
            tituloErrorCamara: '',
            mensajeErrorCamara: '',
            cooldownScanTimer: null,
            ultimoSkuProcesado: '',
        };
    },
    computed: {
        pendientesImprimir() {
            return this.listaHabladores.filter(item => !item.fecha_impresion);
        },
        esAbierta() {
            return !!this.listaActual && this.listaActual.estatus === 'A';
        },
        esCerrada() {
            return !!this.listaActual && this.listaActual.estatus === 'C';
        },
        maxProductos() {
            return this.listaActual && this.listaActual.max_productos ? this.listaActual.max_productos : 200;
        },
        listaLlena() {
            return this.listaHabladores.length >= this.maxProductos;
        },
        puedeAgregar() {
            return this.esAbierta && !this.listaLlena;
        },
        getInspirationalPlaceholder() {
            return 'Escribe algo inspirador ' + String.fromCharCode(10024);
        },
        listaFiltrada() {
            if (!this.filtroLista || !this.filtroLista.trim()) {
                return this.listaHabladores;
            }
            const f = this.filtroLista.trim().toLowerCase();
            return this.listaHabladores.filter(item =>
                (item.sku && String(item.sku).toLowerCase().includes(f)) ||
                (item.nombre && String(item.nombre).toLowerCase().includes(f)) ||
                (item.barra_ingresada && String(item.barra_ingresada).toLowerCase().includes(f))
            );
        },
        pdfReportUrl() {
            if (!this.current.tienda || this.listaHabladores.length === 0) return '';
            const baseApiUrl = process.env.VUE_APP_ROOT_API;
            const skusJoin = this.listaHabladores.map(item => item.sku).join(',');
            return `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/HabladoresEscaneadosPorTienda.jrxml&tienda=${this.current.tienda}&sku=${skusJoin}`;
        },
        fechaHoy() {
            const d = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },
        fechaInicioValidez() {
            const d = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            return `01/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
        }
    },
    watch: {
        etiqueta1Texto(newValue) {
            if (this.imprimirLoMismo) {
                this.etiqueta2Texto = newValue;
            }
        },
        'current.tienda': function() {
            this.volverAListas();
        },
    },
    methods: {
        syncEtiquetas() {
            if (this.imprimirLoMismo) {
                this.etiqueta2Texto = this.etiqueta1Texto;
            } else {
                this.etiqueta2Texto = '';
            }
        },
        deshacerCambios() {
            let self = this;
            self.etiqueta1Texto = '';
            self.etiqueta2Texto = '';
        },
        imprimirEtq() {
            const baseApiUrl = process.env.VUE_APP_ROOT_API;
            window.open(
                `${baseApiUrl}/cat/reporte/?report_name=catalogos/Barra_custom.jrxml&texto1=${this.etiqueta1Texto}&texto2=${this.etiqueta2Texto}`
            );
        },

        // Métodos Pestaña 2: Lista de Habladores
        limpiarInputBusqueda() {
            this.busquedaProducto = '';
            this.refocusInput();
        },
        refocusInput() {
            this.$nextTick(() => {
                if (this.$refs.inputBusqueda) {
                    this.$refs.inputBusqueda.focus();
                }
            });
        },
        abrirPrevisualizacion() {
            if (this.listaHabladores.length === 0) {
                Notifications.alert.warning("Lista Vacía", "Agregue habladores antes de previsualizar.");
                return;
            }
            this.modalPrevisualizacion = true;
        },
        buscarYAgregarProducto() {
            if (!this.puedeAgregar) {
                return;
            }

            const query = this.busquedaProducto ? this.busquedaProducto.trim() : '';
            if (!query) {
                return;
            }

            // Limpiar input inmediatamente para que la colectora escanee de corrido sin perder texto
            this.busquedaProducto = '';

            // Si ya hay una búsqueda ejecutándose en red, encolar el código escaneado
            if (this.cargandoBusqueda) {
                this.scanQueue.push(query);
                Notifications.toast.info("Escaneo Encolado", `Código '${query}' retenido en cola de procesamiento...`);
                return;
            }

            this.ejecutarBusquedaItem(query);
        },

        ejecutarBusquedaItem(query) {
            if (!this.listaActual) return;
            const listaId = this.listaActual.id;
            this.cargandoBusqueda = true;

            // El backend resuelve SKU o barra, valida la asignacion a la tienda,
            // el tope de productos, que la lista siga abierta y los duplicados
            // (tambien los agregados desde otros equipos).
            HabladorListaService.agregar(listaId, query)
                .then((res) => {
                    // Si el usuario salio de la lista mientras se agregaba, se descarta
                    if (!this.listaActual || this.listaActual.id !== listaId) return;
                    const linea = res.data.linea;
                    const existe = this.listaHabladores.some(p => p.id === linea.id);
                    if (!existe) {
                        this.listaHabladores.unshift(linea);
                    }
                    this.listaActual = res.data.lista;
                    Notifications.toast.success("Producto Agregado", `SKU ${linea.sku} añadido a la lista.`);
                })
                .catch((err) => {
                    this.mostrarError(
                        err,
                        "Producto no agregado",
                        `No se pudo agregar el código '${query}'. Si escaneó con cámara, verifique sostener la etiqueta al derecho (con los números orientados hacia abajo).`
                    );
                    // Otro usuario pudo cerrar o anular la lista: se refresca su estado
                    const data = err && err.response ? err.response.data : null;
                    if (data && data.detail && this.listaActual && this.listaActual.id === listaId) {
                        this.scanQueue = [];
                        this.cargarDetalle();
                    }
                })
                .finally(() => {
                    this.cargandoBusqueda = false;

                    this.$nextTick(() => {
                        this.refocusInput();
                        if (this.$refs.tablaContainer) {
                            this.$refs.tablaContainer.scrollTop = 0;
                        }
                    });

                    if (this.scanQueue.length > 0 && this.puedeAgregar) {
                        const nextQuery = this.scanQueue.shift();
                        this.ejecutarBusquedaItem(nextQuery);
                    }
                });
        },
        mostrarError(err, titulo, porDefecto) {
            // El 403 ya lo notifica Api.js
            if (err && err.response && err.response.status === 403) {
                return;
            }
            let mensaje = porDefecto;
            const data = err && err.response ? err.response.data : null;
            if (data) {
                const valor = data.codigo || data.tienda || data.detail || data.non_field_errors;
                if (valor) {
                    mensaje = Array.isArray(valor) ? valor.join(' ') : String(valor);
                }
            }
            Notifications.alert.warning(titulo, mensaje);
        },
        formatearFecha(valor) {
            if (!valor) return '';
            const d = new Date(valor);
            if (isNaN(d.getTime())) return valor;
            const pad = (n) => String(n).padStart(2, '0');
            return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },
        cargarListas() {
            const tienda = this.current.tienda;
            if (!tienda) {
                this.listas = [];
                return Promise.resolve();
            }
            this.cargandoListas = true;
            return HabladorListaService.listar(tienda)
                .then((res) => {
                    // Si cambio la tienda mientras cargaba, se descarta la respuesta
                    if (tienda !== this.current.tienda) return;
                    this.listas = Array.isArray(res.data) ? res.data : (res.data.results || []);
                })
                .catch((err) => {
                    this.mostrarError(err, "Error al cargar", "No se pudieron cargar las listas de habladores de la tienda.");
                })
                .finally(() => {
                    this.cargandoListas = false;
                });
        },
        crearLista() {
            if (!this.current.tienda) {
                Notifications.alert.warning("Selección de Tienda", "Debe seleccionar una tienda asignada a su usuario.");
                return;
            }
            this.creandoLista = true;
            HabladorListaService.crear(this.current.tienda)
                .then((res) => {
                    this.mostrarDetalle(res.data, []);
                    Notifications.toast.success("Lista Creada", "Escanee los productos a agregar.");
                })
                .catch((err) => {
                    this.mostrarError(err, "No se pudo crear", "No se pudo crear la lista de habladores.");
                })
                .finally(() => {
                    this.creandoLista = false;
                });
        },
        mostrarDetalle(lista, lineas) {
            this.listaActual = lista;
            this.listaHabladores = lineas;
            this.filtroLista = '';
            this.scanQueue = [];
            this.vista = 'detalle';
            this.refocusInput();
        },
        abrirLista(lista) {
            this.mostrarDetalle(lista, []);
            this.cargarDetalle();
        },
        continuarLista(lista) {
            if (lista.estatus === 'A') {
                this.abrirLista(lista);
                return;
            }
            Notifications.alert.confirm(
                "Reabrir Lista",
                "¿Desea reabrir la lista para agregar productos? Mientras esté abierta no se podrá imprimir.",
                "Reabrir",
                () => {
                    HabladorListaService.reabrir(lista.id)
                        .then((res) => {
                            this.abrirLista(res.data);
                        })
                        .catch((err) => {
                            this.mostrarError(err, "No se pudo reabrir", "No se pudo reabrir la lista.");
                            this.cargarListas();
                        });
                }
            );
        },
        anularLista(lista) {
            Notifications.alert.confirm(
                "Anular Lista",
                `¿Está seguro de anular la lista creada por ${lista.usuario_crea_nombre} con ${lista.total_productos} producto(s)?`,
                "Anular",
                () => {
                    HabladorListaService.anular(lista.id)
                        .then(() => {
                            Notifications.toast.success("Lista Anulada", "Se anuló la lista de habladores.");
                        })
                        .catch((err) => {
                            this.mostrarError(err, "No se pudo anular", "No se pudo anular la lista.");
                        })
                        .finally(() => {
                            this.cargarListas();
                        });
                }
            );
        },
        volverAListas() {
            if (this.modalCamara) {
                this.cerrarScannerCamara();
            }
            this.scanQueue = [];
            this.listaActual = null;
            this.listaHabladores = [];
            this.filtroLista = '';
            this.vista = 'listas';
            this.cargarListas();
        },
        cargarDetalle() {
            if (!this.listaActual) return Promise.resolve();
            const listaId = this.listaActual.id;
            this.cargandoLista = true;
            return HabladorListaService.detalle(listaId)
                .then((res) => {
                    // Si el usuario salio de la lista mientras cargaba, se descarta
                    if (!this.listaActual || this.listaActual.id !== listaId) return;
                    this.listaActual = res.data.lista;
                    this.listaHabladores = res.data.lineas || [];
                })
                .catch((err) => {
                    if (err && err.response && err.response.status === 404) {
                        Notifications.alert.warning("Lista no disponible", "La lista fue anulada o ya se eliminó.");
                        this.volverAListas();
                        return;
                    }
                    this.mostrarError(err, "Error al cargar", "No se pudo cargar la lista de habladores.");
                })
                .finally(() => {
                    this.cargandoLista = false;
                });
        },
        cerrarLista() {
            if (!this.esAbierta) return;
            const listaId = this.listaActual.id;
            Notifications.alert.confirm(
                "Cerrar Lista",
                "¿Terminó de agregar productos? Al cerrar, la lista queda disponible para imprimir y ya no se podrán agregar productos, salvo que se reabra.",
                "Cerrar Lista",
                () => {
                    HabladorListaService.cerrar(listaId)
                        .then((res) => {
                            if (!this.listaActual || this.listaActual.id !== listaId) return;
                            this.listaActual = res.data;
                            this.scanQueue = [];
                            if (this.modalCamara) {
                                this.cerrarScannerCamara();
                            }
                            Notifications.toast.success("Lista Cerrada", "La lista está disponible para imprimir.");
                        })
                        .catch((err) => {
                            this.mostrarError(err, "No se pudo cerrar", "No se pudo cerrar la lista.");
                            this.cargarDetalle();
                        });
                }
            );
        },
        reabrirListaActual() {
            if (!this.esCerrada) return;
            HabladorListaService.reabrir(this.listaActual.id)
                .then((res) => {
                    this.listaActual = res.data;
                    this.refocusInput();
                    Notifications.toast.info("Lista Reabierta", "Puede agregar más productos.");
                })
                .catch((err) => {
                    this.mostrarError(err, "No se pudo reabrir", "No se pudo reabrir la lista.");
                    this.cargarDetalle();
                });
        },
        eliminarHablador(item) {
            if (!this.esAbierta) return;
            HabladorListaService.quitar(this.listaActual.id, item.id)
                .then((res) => {
                    this.listaHabladores = this.listaHabladores.filter(p => p.id !== item.id);
                    this.listaActual = res.data;
                    Notifications.toast.info("Producto Eliminado", "Se removió el elemento de la lista.");
                })
                .catch((err) => {
                    this.mostrarError(err, "No se pudo eliminar", "No se pudo remover el producto de la lista.");
                    this.cargarDetalle();
                });
        },
        imprimirHabladorIndividual(item) {
            this.imprimirLineas([item], "Sin Producto", "No hay producto para imprimir.");
        },
        imprimirListaCompleta() {
            this.imprimirLineas(
                this.listaHabladores,
                "Lista Vacía",
                "No hay habladores escaneados en la lista para imprimir."
            );
        },
        imprimirPendientes() {
            this.imprimirLineas(
                this.pendientesImprimir,
                "Sin Pendientes",
                "Todos los habladores de la lista ya fueron enviados a imprimir."
            );
        },
        urlReporte(lineas) {
            const baseApiUrl = process.env.VUE_APP_ROOT_API;
            const skusJoin = lineas.map(item => item.sku).join(',');
            return `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/HabladoresEscaneadosPorTienda.jrxml&tienda=${encodeURIComponent(this.listaActual.tienda)}&sku=${encodeURIComponent(skusJoin)}`;
        },
        imprimirLineas(lineasOrigen, tituloVacio, mensajeVacio) {
            if (!this.esCerrada) {
                Notifications.alert.warning("Lista Abierta", "Cierre la lista antes de imprimir.");
                return;
            }
            const lineas = lineasOrigen.slice();
            if (lineas.length === 0) {
                Notifications.alert.warning(tituloVacio, mensajeVacio);
                return;
            }
            const listaId = this.listaActual.id;
            const url = this.urlReporte(lineas);

            // La ventana se abre en el clic para que el navegador no la bloquee
            // como pop-up; el PDF se carga solo si el servidor confirma que la
            // lista sigue cerrada y registra la impresion.
            const ventana = window.open('', '_blank');
            HabladorListaService.marcar_impreso(listaId, lineas.map(item => item.id))
                .then((res) => {
                    if (ventana) {
                        ventana.location.href = url;
                    } else {
                        window.open(url);
                    }
                    if (!this.listaActual || this.listaActual.id !== listaId) return;
                    const actualizadas = {};
                    (res.data.lineas || []).forEach(item => {
                        actualizadas[item.id] = item;
                    });
                    this.listaHabladores = this.listaHabladores.map(item => actualizadas[item.id] || item);
                    this.listaActual = res.data.lista;
                    Notifications.toast.success("Imprimiendo", `Se generó el PDF con ${lineas.length} producto(s).`);
                })
                .catch((err) => {
                    if (ventana) {
                        ventana.close();
                    }
                    this.mostrarError(err, "No se pudo imprimir", "No se registró la impresión y el PDF no se generó.");
                    this.cargarDetalle();
                });
        },

        // Métodos de Escáner por Cámara (Smartphone)
        abrirScannerCamara() {
            if (!this.current.tienda) {
                Notifications.alert.warning("Selección de Tienda", "Debe seleccionar una tienda asignada a su usuario antes de abrir el escáner.");
                return;
            }

            this.errorCamara = false;
            this.tituloErrorCamara = '';
            this.mensajeErrorCamara = '';
            this.ultimoCodigoScan = '';
            this.ultimoSkuProcesado = '';

            const isSecure = window.isSecureContext || window.location.protocol === 'https:' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                this.errorCamara = true;
                this.tituloErrorCamara = "Cámara No Soportada";
                this.mensajeErrorCamara = "Su navegador o dispositivo no admite el acceso a la cámara mediante HTML5.";
            } else if (!isSecure) {
                this.errorCamara = true;
                this.tituloErrorCamara = "Conexión No Segura (HTTP)";
                this.mensajeErrorCamara = "Los navegadores móbiles requieren ingresar mediante HTTPS para habilitar la cámara. Contacte al administrador para verificar la conexión HTTPS.";
            }

            this.modalCamara = true;
            this.$nextTick(() => {
                this.camaraActiva = true;
            });
        },
        cerrarScannerCamara() {
            this.camaraActiva = false;
            this.modalCamara = false;
            if (this.cooldownScanTimer) {
                clearTimeout(this.cooldownScanTimer);
                this.cooldownScanTimer = null;
            }
        },
        onCamaraLoaded(info) {
            // El foco continuo y el zoom los aplica EscanerCamaraBarras al abrir la camara
            this.motorCamara = info && info.motor ? info.motor : '';
        },
        onCamaraError(mensaje) {
            this.camaraActiva = false;
            this.errorCamara = true;
            this.tituloErrorCamara = "No se pudo usar la cámara";
            this.mensajeErrorCamara = mensaje;
        },
        onCamaraDecode(result) {
            if (!result) return;
            const code = String(result).trim();
            if (!code) return;

            // En modo continuo el mismo producto puede seguir frente a la camara:
            // si ya esta en la lista no se consulta al servidor
            if (this.listaHabladores.some(p => p.barra_ingresada === code || p.sku === code)) {
                if (this.ultimoCodigoScan !== code) {
                    this.ultimoCodigoScan = code;
                    Notifications.toast.info("Ya en la lista", `El código ${code} ya está en la lista.`);
                }
                return;
            }

            // Prevenir lecturas repetidas en ráfaga para el mismo producto (cooldown de 1.8 segundos)
            if (this.ultimoSkuProcesado === code && this.cooldownScanTimer) {
                return;
            }

            this.ultimoSkuProcesado = code;
            this.ultimoCodigoScan = code;
            this.codigoRecienteScan = true;

            // Tono auditivo de confirmación (Beep agudo)
            this.reproducirBeepSound();

            setTimeout(() => {
                this.codigoRecienteScan = false;
            }, 350);

            if (this.cooldownScanTimer) clearTimeout(this.cooldownScanTimer);
            this.cooldownScanTimer = setTimeout(() => {
                this.cooldownScanTimer = null;
                this.ultimoSkuProcesado = '';
            }, 1800);

            // Agregar producto escaneado a la lista
            this.ejecutarBusquedaItem(code);

            // Si el modo continuo está desactivado, cerrar escáner
            if (!this.escaneoContinuo) {
                setTimeout(() => {
                    this.cerrarScannerCamara();
                }, 600);
            }
        },
        reproducirBeepSound() {
            // Vibracion corta como confirmacion adicional (Android)
            if (navigator.vibrate) {
                try {
                    navigator.vibrate(60);
                } catch (e) {
                    // No soportado
                }
            }
            try {
                const AudioCtx = window.AudioContext || window.webkitAudioContext;
                if (!AudioCtx) return;
                // Un solo AudioContext reutilizado: crear uno por lectura agota el limite del navegador
                if (!this.audioCtxBeep) {
                    this.audioCtxBeep = new AudioCtx();
                }
                const audioCtx = this.audioCtxBeep;
                if (audioCtx.state === 'suspended') {
                    audioCtx.resume();
                }
                const osc = audioCtx.createOscillator();
                const gain = audioCtx.createGain();
                osc.type = "sine";
                osc.frequency.setValueAtTime(1750, audioCtx.currentTime);
                gain.gain.setValueAtTime(0.25, audioCtx.currentTime);
                osc.connect(gain);
                gain.connect(audioCtx.destination);
                osc.start();
                osc.stop(audioCtx.currentTime + 0.12);
            } catch (e) {
                // Ignore audio context autoplay restrictions gracefully
            }
        },
    },
};
</script>

<style scoped>
.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider-button {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
}

.slider-button:before {
    position: absolute;
    content: "";
    height: 17px;
    width: 17px;
    left: 1px;
    bottom: 1px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
}

input:checked+.slider-button {
    background-color: #4CAF50;
}

input:checked+.slider-button:before {
    transform: translateX(20px);
}

/* Botones de acción y touch targets amplios */
.btn-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    font-weight: 600;
    min-height: 42px;
    border-radius: 6px;
    transition: all 0.2s ease-in-out;
}

.btn-touch-action {
    min-height: 40px;
    min-width: 44px;
    padding: 6px 14px;
    font-weight: bold;
    margin: 3px !important;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.btn-action i {
    margin-right: 8px;
    font-size: 1.1em;
}

.header-actions-group {
    gap: 8px;
}

.cell-acciones {
    padding: 8px !important;
    min-width: 170px;
}

/* Optimizaciones para Dispositivos Móviles y Colectoras PDT */
@media (max-width: 768px) {
    .header-actions-group {
        width: 100%;
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 10px !important;
        margin-top: 8px;
    }

    .header-actions-group .btn-action {
        width: 100% !important;
        min-height: 46px !important;
        margin: 0 !important;
        font-size: 15px !important;
        justify-content: center !important;
    }

    .header-actions-group input.form-control {
        width: 100% !important;
        margin: 0 0 8px 0 !important;
    }

    .btn-touch-action {
        min-height: 44px; /* Tamaño recomendado para dedos gruesos */
        padding: 8px 16px;
        font-size: 14px;
        margin: 4px !important;
    }

    .nav-tabs .nav-link {
        padding: 10px 14px;
        font-size: 14px;
        font-weight: 600;
    }

    .form-header {
        font-size: 1.1rem;
    }

    .table-responsive {
        font-size: 13px;
        -webkit-overflow-scrolling: touch;
    }

    .badge {
        font-size: 11px;
    }

    .modal-dialog {
        margin: 0.5rem;
    }

    .col-camara-wrapper {
        width: 100%;
        margin-top: 6px;
    }
    .btn-camara-action {
        width: 100% !important;
        min-height: 44px !important;
    }
}

.btn-camara-action {
    height: 38px;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

/* Escáner de Cámara Smartphone */
.scanner-viewport-wrapper video {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 8px;
}

.scanner-target-box {
    width: 260px;
    height: 150px;
    border: 3px solid #17a2b8;
    border-radius: 12px;
    box-shadow: 0 0 0 4000px rgba(0, 0, 0, 0.5);
    transition: all 0.2s ease-in-out;
}

.scanner-target-box.scanned-flash {
    border-color: #28a745 !important;
    box-shadow: 0 0 0 4000px rgba(40, 167, 69, 0.4), 0 0 25px #28a745 !important;
}

.laser-line {
    position: absolute;
    top: 50%;
    left: 12px;
    right: 12px;
    height: 3px;
    background-color: #ff3b30;
    box-shadow: 0 0 10px #ff3b30, 0 0 4px #ff3b30;
    border-radius: 2px;
    animation: laserScanAnim 2s infinite ease-in-out;
}

@keyframes laserScanAnim {
    0%, 100% { top: 12%; }
    50% { top: 88%; }
}
</style>
